<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.fido.passkey.registration.label')"
                           :parentScreen="parentScreen">
        <template>
            <div class="form-group row">
                <div class="col-12">
                    <div class="alert alert-warning mb-0">
                        <p class="mb-2">生体認証やデバイスのロック解除機能を使って、安全かつ簡単にログインや重要なお手続きを行うことができます。</p>
                        <b class="text-danger">パスキーは個人端末のみ登録してください</b>
                        <p class="text-danger mb-0">※追加時にはその端末で承認が必要です</p>
                        <p class="text-danger mb-0">※生体認証は端末上で行われるため、お客様の生体情報が当社へ送信・保存されることはありません。</p>
                    </div>
                </div>
            </div>

            <div class="form-group row justify-content-center">
                <div class="col-12 col-sm-6 col-md-5">
                    <button class="btn btn-sm btn-primary w-100" @click.prevent="showRegisterPasskeyModal()">
                        <span>パスキーを追加</span>
                    </button>
                </div>
            </div>
            <div class="form-group row justify-content-center">
                <div class="col-12 col-sm-6 col-md-5 text-center">
                    <a :href=this.securityLink target="_blank">ご利用の端末で追加できない場合</a>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-12">
                    <b>登録済みの端末情報</b>
                </div>
            </div>
            <div class="form-group row" v-if="!this.registeredPasskeys || this.registeredPasskeys.length === 0">
                <div class="col-12">
                    <div class="alert alert-warning mb-0">
                        パスキーは登録されていません。
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="registeredPasskey in registeredPasskeys" :key="registeredPasskey.customerPasskeyId"
                     class="row mb-2 ml-0 mr-0 passkey-item align-items-center p-2 rounded">
                    <div class="col-10 col-md-10 pl-1 pr-1">
                        <p class="mb-2 fs-13px">{{ registeredPasskey?.providerName || ''}}</p>
                        <p class="mb-2">作成日時 : {{ registeredPasskey?.registrationDate || ''}}</p>
                        <p class="mb-2">最終使用日時 : {{ registeredPasskey?.lastUsedDate || ''}}</p>
                    </div>
                    <div class="col-2 col-md-2 pl-1 pr-1 d-flex justify-content-end mt-2 mt-md-0">
                        <button class="btn btn-sm btn-danger text-nowrap"
                                :disabled="registeredPasskeys.length === 1"
                                @click.prevent="initDeletePasskey(registeredPasskey)">
                            削除
                        </button>
                    </div>
                </div>
            </div>
            <div class="form-group row justify-content-center mb-0">
                <div class="col-12 col-sm-4 col-md-3 mt-2">
                    <button class="btn btn-sm btn-default w-100" @click.prevent="reverseInput">
                        <span>キャンセル</span>
                    </button>
                </div>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>

<script>
    import formMixin from '@/common/mixins/form';
    import forceNewUtil from "@/common/mixins/forceNewUtil";
    import Config from "@/services/Config";
    import IConstants from "@/common/constants/IConstants";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import {createNamespacedHelpers} from "vuex";
    import $ from "jquery";

    const {mapState: mapProfileState, mapMutations: mapProfileMutations} = createNamespacedHelpers("editProfile")

    export default {
        name: "RegisteredPasskeys",
        props: {
            displayForms: {
                type: String,
                required: false,
                default: ''
            },
        },
        mixins: [formMixin, forceNewUtil],
        data() {
            return {
                securityLink: Config.getRegisterPasskeySecurityLink(),
                registeredPasskeys: null
            }
        },
        computed: {
            ...mapProfileState({
                profileState: state => state,
            })
        },
        created() {
        },
        mounted() {
            this.listenEvents()
        },
        beforeDestroy() {
            this.unListenEvents()
        },
        methods: {
            ...mapProfileMutations(['assignProfileState']),
            listenEvents() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.RELOAD_REGISTERED_PASSKEYS, () => {
                    this.$modal.showProfileMessage({
                        message: {},
                    });
                    return this.getPasskeys()
                });
            },
            unListenEvents() {
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.RELOAD_REGISTERED_PASSKEYS);
            },
            getPasskeys() {
                this.$service.getService(IConstants.SERVICE_NAME.FIDO).getPasskeys().then((res) => {
                    if (res.errorMessage) {
                        return this.$modal.showProfileMessage({
                            message: {
                                errorMessage: 'MSG_NAB005'
                            },
                            callBackFunc: () => {
                                $("html, body").animate({scrollTop: 0}, "slow", () => {
                                    this.reverseInput();
                                });
                            }
                        })
                    }
                    this.registeredPasskeys = res.registeredPasskeys;
                    if (res.registeredPasskeys?.length >= 1 && String(this.profileState.passkeyStatus) !== String(IConstants.PASSKEY_STATUS.ALREADY_SET))
                        this.assignProfileState({passkeyStatus: IConstants.PASSKEY_STATUS.ALREADY_SET});
                })
            },
            showRegisterPasskeyModal() {
                this.$modal.showRegisterPasskeyModal()
            },
            initDeletePasskey(registeredPasskey) {
                if (this.registeredPasskeys.length === 1) return;
                this.$modal.showConfirmDeletePasskey(registeredPasskey);
            },
        },
        validations() {
            return {}
        },
        watch: {
            'profileState.activeBlock': {
                handler() {
                    if (String(this.profileState?.activeBlock) === "REGISTERED_PASSKEYS") this.getPasskeys()
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .passkey-item {
        background-color: rgba(253, 251, 243, 0.9);
        border: 1px solid rgba(243, 233, 199, 0.9);
        color: #9a7a3a;
    }
</style>